import { createTheme } from '@material-ui/core'

export default createTheme({
    components: {
        MuiIconButton: {
            variants: [
                {
                    props: { variant: 'funky' },
                    style: {
                        borderRadius: 8,
                        background: 'linear-gradient(138.72deg, #DC8295 0%, #DC687C 95.83%)',
                        boxShadow: '0px 10px 10px rgba(221, 114, 133, 0.2)',
                        color: '#fff',
                        padding: 16
                    }
                }
            ]
        }
    },
    palette: {
        background: {
            default: '#F1F3F4'
        },
        primary: {
            main: '#14194C',
        },
    },
    typography: {
        fontFamily: 'Mulish, sans-serif',
        allVariants: {
            '&.capitalize::first-letter': {
                textTransform: 'capitalize'
            }
        },
        h4: {
            fontWeight: 800
        },
        h5: {
            fontWeight: 800
        },
        h6: {
            fontWeight: 800
        },
        subtitle1: {
            fontWeight: 800

        }
    }
})